import { useMutation } from '@tanstack/react-query';
import { deleteUserAccount } from 'api/delete-user-account';

export function useDeleteAccount() {
  return useMutation({
    mutationFn: deleteUserAccount,
  });
}
